

export default (state = [], action) => {
    if (action.type === 'FETCH_ITEMS' || action.type === 'LOAD_MORE') {
        return action.payload.finalCount || [];
    }

    return state
}